export enum dateRange {
  ThisMonth = 'this-month',
  PreviousMonth = 'previous-month',
}
